import { render, staticRenderFns } from "./dui-social-links.vue?vue&type=template&id=57644b70&scoped=true&"
import script from "./dui-social-links.vue?vue&type=script&lang=js&"
export * from "./dui-social-links.vue?vue&type=script&lang=js&"
import style0 from "./dui-social-links.vue?vue&type=style&index=0&id=57644b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57644b70",
  null
  
)

export default component.exports